<template>
<div class="IndexBanner">
    <ul>
        <li v-for="(item,idx) in staticLinks" :key="idx+'bn'">
             <a href="javascript:;" @click="toFastUri(item)">
                <bn-icon :name="item.icon" />
                <span>{{item.name}}</span>
            </a>
        </li>
        <!-- <li>
            <a href="http://goglobal.shisu.edu.cn/fa-sys/public/publicity-info-list" target="_blank">
                <bn-icon name="public" />
                <span>出访公示</span>
            </a>
        </li> -->
    </ul>
    <banner-img id="bg"/> 
</div>
</template>
<script>
import BnIcon from '../common/bannerIcons.vue'
export default {
    data(){
        return {
            
        }
    },
    inject:['toUri'],
    components:{
        BnIcon
    },
    methods:{
        toFastUri(item){
          item.uri?this.toUri(item.uri):this.$message.info(`您当前没有关于${item.name}的办理权限`);
        },  
    },
    computed:{
        staticLinks(){
            return this.$store.getters.getFastBtns;
        },
    }

}
</script>


// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/Banner.vue